import { Compass, Gift, Heart, Home, UserRound } from 'lucide-react';
import type { NavKey } from './Header';

interface BottomNavProps {
  active: NavKey;
  onNavigate: (key: NavKey) => void;
  onOpenShop: () => void;
  onOpenTools: () => void;
}

export function BottomNav({ active, onNavigate, onOpenShop, onOpenTools }: BottomNavProps) {
  return (
    <nav className="bottom-nav" aria-label="Mobile navigation">
      <button className={active === 'home' ? 'active' : ''} onClick={() => onNavigate('home')}><Home /><span>Home</span></button>
      <button className={active === 'browse' ? 'active' : ''} onClick={() => onNavigate('browse')}><Compass /><span>Discover</span></button>
      <button className={active === 'my-list' ? 'active' : ''} onClick={() => onNavigate('my-list')}><Heart /><span>My list</span></button>
      <button onClick={onOpenShop}><Gift /><span>Rewards</span></button>
      <button onClick={onOpenTools}><UserRound /><span>Profile</span></button>
    </nav>
  );
}
